import {
  AnnouncementMediaUploadStatus,
  type AnnouncementMediaUploadEntry,
} from '@/app/pages/notifications/announcements/core/_models';

type AnnouncementMediaUploadListProps = {
  entries: AnnouncementMediaUploadEntry[];
  onRetry: (id: string) => void;
  onRemove: (id: string) => void;
};

const AnnouncementMediaUploadList = ({ entries, onRetry, onRemove }: AnnouncementMediaUploadListProps) => (
  <ul aria-label="Envio de mídias" aria-live="polite" className="list-unstyled mt-3 mb-0">
    {entries.map((entry) => (
      <li key={entry.id} className="d-flex align-items-center flex-wrap gap-3 py-2">
        <span className="text-break">{entry.filename}</span>
        {entry.status === AnnouncementMediaUploadStatus.QUEUED && <span>Aguardando envio</span>}
        {entry.status === AnnouncementMediaUploadStatus.UPLOADING && (
          <progress aria-label={`Enviando ${entry.filename}`} max={100} value={entry.progress} />
        )}
        {entry.status === AnnouncementMediaUploadStatus.FAILED && (
          <>
            <span className="text-danger">{entry.error}</span>
            <button className="btn btn-sm btn-light" type="button" onClick={() => onRetry(entry.id)}>
              Tentar novamente
            </button>
          </>
        )}
        <button className="btn btn-sm btn-light-danger" type="button" onClick={() => onRemove(entry.id)}>
          Remover
        </button>
      </li>
    ))}
  </ul>
);

export default AnnouncementMediaUploadList;
